import { Entity, Field } from "typegraph";

import IdName from "core/util/IdName";
import Badge from "./Badge";
import Tag from "./Tag";
import ProgramCourse from "./ProgramCourse";

enum Completion {
	NotStarted = "NotStarted",
	Started = "Started",
	Incomplete = "Incomplete",
	Completed = "Completed",
	Passed = "Passed",
	Failed = "Failed"
}

class Credit {
	@Field()
	public id: string;

	@Field()
	public value: number;

	@Field({ entity: IdName })
	public creditType: IdName;
}

export class ProductType {

	@Field()
	public name: string;

	@Field()
	public iconUrl: string;

}

export class Variant {

	@Field()
	public id: string;

	@Field()
	public price: number;

	@Field()
	public buyUrl: string;

	@Field()
	public title: string;

	@Field()
	public repurchaseVariant: boolean;

	@Field()
	public extensionType: string;

	@Field()
	public displayOnly: boolean;

}

@Entity({
	one: "course_one",
	many: "course_many_user",
	create: "course_enroll",
	update: "course_enroll",
})
export default class Course {
	@Field()
	public id: string; // id of Entry.java (catalog_entry)

	@Field()
	public metaId: string;

	@Field()
	public subscriptionId: string;

	@Field()
	public infoUrl: string;

	@Field()
	public itemExternalId?: string; // for language packages, top level ext id

	@Field()
	public metaItemExternalId?: string; // for language packages, child ext id

	@Field()
	public language?: string;

	@Field()
	public title: string;

	@Field()
	public subTitle: string;

	@Field()
	public keywords?: string;

	@Field()
	public description?: string;

	@Field()
	public customField1?: string;

	@Field()
	public customField2?: string;

	@Field()
	public customField3?: string;

	@Field()
	public customField4?: string;

	@Field()
	public shortDescription: string;

	@Field()
	public iconUrl: string;

	@Field()
	public smallIconUrl: string;

	@Field()
	public canLaunch: boolean;

	@Field()
	public canBuy: boolean;

	@Field()
	public canExtend: boolean;

	@Field()
	public activeSubscriptionExists: boolean;

	@Field()
	public completion: Completion;

	@Field()
	public startDate: string;

	@Field()
	public endDate: string;

	@Field()
	public displayStartDate: string;

	@Field()
	public displayEndDate: string;

	@Field()
	public progress: number;

	@Field()
	public grade: string;

	@Field()
	public dueDates: string[];

	@Field({ entity: Credit })
	public credits?: null | Credit[];

	@Field({ entity: Tag })
	public tags: Tag[];

	@Field()
	public launchURL: string;

	@Field({ entity: ProductType, aliasFor: "itemType" })
	public productType: ProductType;

	@Field({ entity: Variant })
	public variants?: Variant[];

	@Field({ entity: Badge })
	public badges?: Badge[];

	@Field()
	public baseType: string;

	@Field()
	public contentId: string;

	@Field({
		entity: ProgramCourse,
		includeIf: (data: any) => !!data.loadPrograms,
	})
	public program?: ProgramCourse;

	@Field()
	public subscriptionEndDate: string;

	@Field()
	public bookmarked: boolean;

	@Field()
	public displayOnly: boolean;

	@Field()
	public avgItemRating: number;

	@Field()
	public userItemRating: number;

	@Field()
	public itemId: string;

	@Field()
	public hideItems: boolean;

	@Field()
	public previewUrl: string;

	@Field()
	public waitingOptionForCourse: boolean;

	@Field()
	public approveWaiting: boolean;
}











// WEBPACK FOOTER //
// ./src/panels/catalog/entities/Course.ts